import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "./Logo";

export default function InfoPage({ title }) {
  return (
    <section className="relative min-h-[80vh] grid place-items-center pt-28 pb-16 px-5" data-testid="page-info">
      <div className="text-center">
        <Logo />
        <p className="eyebrow justify-center mt-8">Tap In</p>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold mt-4" data-testid="info-title">{title}</h1>
        <p className="body-lg mt-4 max-w-md mx-auto">This page is coming soon. We're getting it ready before launch.</p>
        <Link to="/" data-testid="info-home-link" className="btn-primary mt-8">
          <ArrowLeft size={17} /> Back to home
        </Link>
      </div>
    </section>
  );
}
